// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import { FunctionComponent, ReactElement } from "react";
import { Box, CardMedia, LinearProgress, Paper, Stack, Typography } from "@mui/material";
import LoadingImg from '../images/loading.svg';

type LoadingPagePropsInterface = {};

/**
 * loading page.
 *
 * @param {LoadingPagePropsInterface} props - Props injected to the component.
 *
 * @return {React.ReactElement}
 */
export const LoadingPage: FunctionComponent<LoadingPagePropsInterface> = (): ReactElement => {
    return (
        <Box>
            <Box height="100vh" width="100vw" sx={{ display: "flex", flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                <Paper elevation={1} sx={{ height: "90vh", width: "95vw", display: "flex", justifyContent: 'center' }}>
                    <Stack direction="column" spacing={2} justifyContent="center" alignItems="center">
                        <CardMedia
                            sx={{ height: "50vh", width: "40vh" }}
                            component="img"
                            image={LoadingImg}
                            alt="Loading Image"
                        />
                        <Typography p={3} align="center" variant="h4">Loading...</Typography>
                        <LinearProgress sx={{
                            width: '100%', backgroundColor: '#ff7300',
                            "& .MuiLinearProgress-barColorPrimary": { backgroundColor: '#ffd1bf' }
                        }}
                        />
                    </Stack>
                </Paper>
            </Box>
        </Box>
    );
};
